<app-ice-select-box
  class="additional-service-select"
  type="checkbox"
  [control]="selectionControl"
  [disabled]="selectionControl?.disabled"
  [infoText]="additionalService?.longDescription"
  [label]="additionalService.description"
  [readonly]="isLockedIn"
  [reserveSpaceForInfoText]="true"
  [value]="additionalService.productId"
>
  @if (additionalService.price && !isIncluded) {
    <div class="price" inlineHeaderContent>
      {{ additionalService?.price?.includingVAT | priceFormat: PriceType.Monthly }}
    </div>
  }

  @if (additionalService.requireICC && isSelected) {
    <div class="icc-content">
      <div class="icc-input-infotext">(Bruker fysisk SIM-kort)</div>

      <p class="sim-delivery-title">Hvordan får kunden SIM-kortet?</p>
      <div class="sim-delivery-options">
        <app-ice-radio-button
          label="Levert i butikk"
          ngDefaultControl
          [forId]="simDeliveryControlName + '-in-store-' + additionalService.productId"
          [formControlName]="simDeliveryControlName"
          [isBoxVersion]="true"
          [testId]="'sim-delivery-in-store-' + additionalService.productId"
          [value]="SimCardDelivery.InStore"
        />
        <app-ice-radio-button
          label="Sendt i posten"
          ngDefaultControl
          [forId]="simDeliveryControlName + '-by-mail-' + additionalService.productId"
          [formControlName]="simDeliveryControlName"
          [isBoxVersion]="true"
          [testId]="'sim-delivery-by-mail-' + additionalService.productId"
          [value]="SimCardDelivery.ByMail"
        />
      </div>

      @if (isDeliveredInStore) {
        <app-ice-input-field
          inputWidth="medium"
          label="SIM-nummer"
          maxlength="20"
          minlength="19"
          ngDefaultControl
          placeholder="Scan eller skriv inn SIM-nummeret"
          textTestId="icc-input"
          [errorOnTouchedOnly]="true"
          [errorText]="getSimCardErrorTexts(iccField?.errors, getSimCardTypeForService())"
          [forId]="iccControlName + '-' + additionalService.productId"
          [formControlName]="iccControlName"
        />
        @if ((iccField?.statusChanges | async) === FormStatus.PENDING) {
          <app-spinner />
        }
      }
    </div>
  }
</app-ice-select-box>
